<template>
 <div v-loading="MVRVZLoading"   style="width: 100%; min-height: 700px">
   
      <!-- 公式 -->
      <el-row type="flex" justify="center">
      <section class="formulas">
          <div>MVRV-Z Score =</div>
          <div>
            <span>Market Cap - Realized Cap</span>
            <span>Standard Deviation <span style="color:rgba(0,0,0,0.4);border:none">(Market Cap)</span> </span>
          </div>
      </section>
   </el-row>
    <el-row>
      <el-col :span="24">      
        <div
          id="MVRVZBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../MVRVZ/index"
export default {
  mixins:[IndexJs]
}
</script>

<style>

</style>